function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 300,
  height: 300,
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9BD2B",
  d: "M33 179.379L72.0038 218.33H33V179.379ZM33 169.641L81.7548 218.33H120.759L33 130.689V169.641ZM33 120.951L130.51 218.33H169.513L33 82V120.951ZM81.7548 120.951L179.264 218.33V179.379L81.7548 82V120.951ZM130.51 82V120.951L179.264 169.641V130.689L130.51 82Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M267.023 202.75C257.03 202.75 247.451 198.784 240.391 191.734L186.16 137.576V218.33H267.023V202.75Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M209.563 202.75C213.871 202.75 217.363 199.262 217.363 194.959C217.363 190.657 213.871 187.169 209.563 187.169C205.254 187.169 201.762 190.657 201.762 194.959C201.762 199.262 205.254 202.75 209.563 202.75Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#1D4AFF",
  d: "M33 218.33H72.0038L33 179.379V218.33Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#1D4AFF",
  d: "M81.7548 130.689L33 82V120.951L81.7548 169.641V130.689Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#1D4AFF",
  d: "M33 130.689V169.641L81.7548 218.33V179.379L33 130.689Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#F54E00",
  d: "M130.51 130.689L81.7548 82V120.951L130.51 169.641V130.689Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#F54E00",
  d: "M81.7548 218.33H120.759L81.7548 179.379V218.33Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#F54E00",
  d: "M81.7548 130.689V169.641L130.51 218.33V179.379L81.7548 130.689Z"
});

const SvgPosthog = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 300,
  height: 300,
  fill: "none",
  viewBox: "0 0 300 300",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPosthog, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/posthog.36f8ad15.svg";
export { ForwardRef as ReactComponent };